/*
 * アクションバーは画面下部に固定する。片手の親指操作を前提にする（要件12.2）。
 */

/*
 * 下端の余白はここで指定する。グローバルの .safe-bottom と併用すると、読み込み順で
 * この padding が後から当たって下端の余白を消す（実際にホームバー分の余白が一度も
 * 効いていなかった）。値は .safe-bottom と同じ考え方で、セーフエリアに一定の余白を
 * 足す。Safari の下部ツールバーが出ている間はセーフエリアが 0 になるため、足す余白が
 * 指とツールバーの間を空ける。
 */
.bar {
  position: sticky;
  bottom: 0;
  background: var(--mantine-color-dark-8);
  border-top: 0.0625rem solid var(--mantine-color-dark-4);
  padding: var(--mantine-spacing-sm) var(--mantine-spacing-sm)
    calc(var(--mantine-spacing-xl) + env(safe-area-inset-bottom, 0px));
}

/* 自分のターンであることを、画面に視線を戻した瞬間に判別できる強さで示す（要件5.4）。 */
.myTurn {
  border-top: 0.25rem solid var(--mantine-color-yellow-4);
  box-shadow: 0 -0.75rem 1.5rem rgb(250 204 21 / 18%);
}

/*
 * Fold は誤操作を防ぐため他のアクションボタンから離して配置する（要件6.12）。
 * 同じ行に並べず、間隔を空けた別の行に置く。
 */
.foldRow {
  margin-top: var(--mantine-spacing-md);
}

.fold {
  /* 押し間違いを減らすため幅を絞る。 */
  width: 45%;
}

/*
 * 単独で置くアクション（オールインなど）。列に並ばないので、中央で広く取る。
 * フォールドより広くして、こちらが主たる選択肢であることを示す。
 */
.wide {
  width: 70%;
}
